import { computed } from '@ember/object';
import { later } from '@ember/runloop';
import Controller from '@ember/controller';
import { inject as service } from '@ember/service';
import { SH_LOGO_DETAILS } from "../constants/site-header";
import { formatUri, parseUri } from "../utils/misc";
import ENV from '../config/environment';
import { showModal } from "sh-www/utils/modal-controls";

export default Controller.extend({
  errorTracker: service('error-tracker'),

  /**
   * @inheritDoc
   */
  queryParams: ['link'],

  /**
   * @param {String}      Query param of the link we will be navigating to.
   */
  link: '',

  /**
   * @inheritDoc
   */
  navigateToOutUrl() {
    let referrer = document.referrer;
    if (referrer) {
      // if we have a referrer, we need to make sure it has only come form Glimmer.

      let parsedReferrerUri = parseUri(referrer),
        // Use regex to test to make sure any storyhunter subdomains will work as well.
        storyhunterDomainRegex = new RegExp(`${ENV.topLevelDomain.replace('.', '\\.')}$`);
      if (!storyhunterDomainRegex.test(parsedReferrerUri.host)) {
        this.get('errorTracker').error(`BAD-OUTLINK -- bad referrer ${referrer} on link ${this.get('link')}`, this);
        showModal(this, 'alert', {
          titleText: 'Unknown error',
          bodyText: 'There was an error navigating to the link you requested.',
          actionButtonText: 'OK',
        });
        window.location.assign('/');
        return;
      }
    }

    // We do NOT have a referrer OR the referrer is good. In this case, let's go ahead and send
    // them to their destination.  You can have an empty referrer on a link with 'noreferrer' on it.

    later(this, function() {
      let link = this.get('link');
      if (!/^(http|https):\/\//.test(link)) {
        link = `https://${link}`;
      }

      window.location.assign(link);
    }, 1500);
  },

  /**
   * We will show the user a sanitized version of the link.  We are doing this since we will allow
   * any link to be redirected here, but want to ensure that we do our best to show the user
   * where they are going.
   *
   * @type {String}
   */
  _linkSanitized: computed('link', function() {
    let parsedUri = parseUri(this.get('link'));
    parsedUri.auth = '';

    let formattedUri = formatUri(parsedUri);
    return formattedUri;
  }),

  /**
   * @type {String}     The uri of the log image.
   */
  _logoSrc: SH_LOGO_DETAILS.src
});
